import { getDefaultBrowser } from '../utils/defaults';
import { addListenerToWindow } from '../utils/misc';
export var ERROR_SUBJECT_NAME = 'err_0';
export var observeError = function (next, tearDown) {
    var window = getDefaultBrowser();
    if (!window)
        return;
    var removeListener = addListenerToWindow(window, 'error', next, true);
    tearDown(function () {
        removeListener();
    });
};
export var errorSubject = [ERROR_SUBJECT_NAME, observeError];
export var PROMISE_REJECTION_SUBJECT_NAME = 'perr_0';
export var observePromiseRejection = function (next, tearDown) {
    var window = getDefaultBrowser();
    if (!window)
        return;
    var removeListener = addListenerToWindow(window, 'unhandledrejection', next, true);
    tearDown(function () {
        removeListener();
    });
};
export var promiseRejectionSubject = [
    PROMISE_REJECTION_SUBJECT_NAME,
    observePromiseRejection,
];
//# sourceMappingURL=error.js.map